import { render, staticRenderFns } from "./Character.vue?vue&type=template&id=1346f412&scoped=true&"
import script from "./Character.vue?vue&type=script&lang=js&"
export * from "./Character.vue?vue&type=script&lang=js&"
import style0 from "./Character.vue?vue&type=style&index=0&id=1346f412&scoped=true&lang=css&"
import style1 from "../../constant/css/detail.css?vue&type=style&index=1&id=1346f412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1346f412",
  null
  
)

export default component.exports